import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { css } from "styled-components";

// Load all custom state objects so they are included in the bundle.
const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

setPreStyleGuideTheme({
    
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [1280, 1280, 1280, 1280, 1280],
    },
    globalStyle: {
        css: css`
            header {
                padding: 0 !important;
            }
            main {
                padding: 0 !important;
            }
            footer {
                padding: 0 !important;
            }
        `,
    },
    typography: {
        fontFamilyImportUrl: "/staticContent/main.css",
        body: {
            size: "10px",
            color: "#333",
            fontFamily: "'Lato','sans-serif'",
            css: css`
                background:#FFF;
                width:100%;
                margin:0 auto;
            `
        },
        p: {
            size: "10px",
            weight: 400,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h1: {
            size: "40px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h2: {
            size: "32px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h3: {
            size: "28px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h4: {
            size: "24px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h5: {
            size: "20px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h6: {
            size: "16px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        headerPrimary: {
            forwardAs: "p",
            size: "24px",
            color: "primary.main",
            fontFamily: "'Montserrat','sans-serif'",
            transform: "none",
        },
        headerSecondary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Montserrat','sans-serif'",
            transform: "none",
            weight: 500,
        },
        headerTertiary: {
            forwardAs: "p",
            size: "15px",
            color: "primary.contrast",
            fontFamily: "'Montserrat','sans-serif'",
            transform: "none",
            weight: 500,
        },
        legend: {
            forwardAs: "span",
            size: "10px",
            color: "text.accent",
            transform: "none",
            weight: 600,
        },
    },
});
